import styles from "./Containers.module.css";
import DataLabel from "../labels/DataLabel";

const AuditContractorCard = ({ contractorAudit }) => {
  const getAuditDateText = (auditDateTimestamp) => {
    let auditDate = new Date(auditDateTimestamp);
    let dateText =
      auditDate.getDate() +
      "/" +
      (auditDate.getMonth() + 1) +
      "/" +
      auditDate.getFullYear() +
      " " +
      auditDate.getHours() +
      ":" +
      auditDate.getMinutes() +
      ":" +
      auditDate.getSeconds();
    return dateText;
  };

  const getGoogleMapLink = (latitude, longitude) => {
    let coordinatesLink = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    return (
      <button
        className={styles.googleMapLinkButton}
        onClick={() => window.open(coordinatesLink)}
      >
        Google Map Location
      </button>
    );
  };

  return (
    <div className={styles.card}>
      <DataLabel title={"Audit GUID"} text={contractorAudit.AUDIT_GUID} />
      <DataLabel title={"Auditor"} text={contractorAudit.AUDITOR} />
      <DataLabel
        title={"Auditor Full Name"}
        text={contractorAudit?.AUDITOR_FULL_NAME}
      />
      <DataLabel title={"Auditor Email"} text={contractorAudit.AUDITOR_EMAIL} />
      <DataLabel
        title={"Audit Date"}
        text={getAuditDateText(contractorAudit.AUDIT_DATE)}
      />
      <DataLabel
        title={"Location"}
        text={`(${contractorAudit.LATITUDE},${contractorAudit.LONGITUDE})`}
      />
      {contractorAudit.LATITUDE && contractorAudit.LONGITUDE && (
        <DataLabel
          title={"Google Map Location"}
          text={getGoogleMapLink(
            contractorAudit.LATITUDE,
            contractorAudit.LONGITUDE
          )}
        />
      )}
      <DataLabel
        title={"Market"}
        text={contractorAudit.MARKET ? contractorAudit.MARKET : "N/A"}
      />
      <DataLabel
        title={"LCP/Ring/Areaname"}
        text={contractorAudit.AREANAME ? contractorAudit.AREANAME : "N/A"}
      />
      <DataLabel
        title={"Contractor"}
        text={contractorAudit.CONTRACTOR ? contractorAudit.CONTRACTOR : "N/A"}
      />
      <DataLabel
        title={"Crew ID"}
        text={contractorAudit.CREW_GUID ? contractorAudit.CREW_GUID : "N/A"}
      />
      <DataLabel
        title={"In-House Splicer"}
        text={
          contractorAudit.IN_HOUSE_SPLICER
            ? contractorAudit.IN_HOUSE_SPLICER
            : "N/A"
        }
      />
    </div>
  );
};

export default AuditContractorCard;
